import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse, Location } from '@core/models/common.model';

@Injectable({ providedIn: 'root' })
export class LocationService {
  private readonly base = `${environment.apiBaseUrl}/Location`;

  constructor(private readonly http: HttpClient) {}

  addLocation(location: Location): Observable<ApiResponse<Location>> {
    return this.http.post<ApiResponse<Location>>(this.base, location);
  }

  getLocationsByOrganization(tenantId: string): Observable<ApiResponse<Location[]>> {
    return this.http.get<ApiResponse<Location[]>>(`${this.base}/tenant/${tenantId}`);
  }

  getAllLocationsByOrganization(tenantId: string): Observable<ApiResponse<Location[]>> {
    return this.http.get<ApiResponse<Location[]>>(`${this.base}/tenant/${tenantId}/all`);
  }

  updateLocation(location: Location): Observable<ApiResponse<Location>> {
    return this.http.post<ApiResponse<Location>>(`${this.base}/update`, location);
  }

  toggleLocation(id: string, key: string, prop: string): Observable<ApiResponse<Location>> {
    return this.http.get<ApiResponse<Location>>(`${this.base}/toggle/${id}/${key}/${prop}`);
  }
}
